import React, { Fragment } from 'react'

import RangeSlider, { SliderOption } from 'common/RangeSlider'
import { PLAN_TERMS } from 'common/Utils'
import { PlanTerm } from 'common/Products/types'

interface DefaultDynamicPlanFilterProps {
  name?: string
  onChange?: (name: string, position: SliderOption) => void
  isLoading?: boolean
  /** The plan terms there are plans for; the slider shows these, in PLAN_TERMS order */
  terms?: PlanTerm[]
}

const lastContainerStyle = {
  position: 'relative' as 'relative',
  minWidth: '100px',
}

const firstContainerStyle = {
  position: 'relative' as 'relative',
  left: '10px',
}

// This has been too coupled with the label functionality
const customTransformLabel = (position: number, opt: SliderOption) => {
  const getContainerStyle = () => {
    if (opt.position === 0) return firstContainerStyle
    if (opt.position === 100) return lastContainerStyle
    return {}
  }

  return (
    <div className="labelContainer" style={getContainerStyle()}>
      <span className="hiddenSelectRegion" />
      {opt.position === position ? (
        <strong>{opt.label}</strong>
      ) : (
        <span className="unselectedLabel">{opt.label}</span>
      )}
    </div>
  )
}

// One stop per term with plans
const termsToOptions = (terms: PlanTerm[]): SliderOption[] =>
  PLAN_TERMS.filter(({ term }) => terms.includes(term)).map(({ term, label, position }) => ({
    position,
    label,
    value: term,
  }))

const DynamicPlanFilter = ({
  name = '',
  onChange = () => null,
  isLoading = false,
  terms = [],
}: DefaultDynamicPlanFilterProps) => {
  return (
    <Fragment>
      <div style={{ marginBottom: '96px' }}>
        <RangeSlider
          name={name}
          options={termsToOptions(terms)}
          onChange={onChange}
          isLoading={isLoading}
          labelClassName="labelContainer"
          transformLabel={customTransformLabel}
        />
      </div>
    </Fragment>
  )
}

DynamicPlanFilter.defaultProps = {
  name: '',
  onChange: () => null,
  isLoading: false,
  terms: [],
}

export default DynamicPlanFilter
